import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Layout-wide UI state.
 *
 *   - `isWidePage`: lets SidebarLayout drop its max-width cap for pages
 *     that need the full content area (parent-deal race canvas).
 *   - `isTightPage`: lets SidebarLayout drop its `lg:p-10` → `lg:p-6`
 *     for pages that have their own dense header chrome (deal detail).
 *
 * Pages opt in via the respective setter on mount and clean up on
 * unmount.
 *
 * Kept as Redux instead of context so it composes with the rest of the
 * app's state and survives the existing store rehydration patterns.
 */

interface LayoutUiState {
  isWidePage: boolean;
  isTightPage: boolean;
}

const initialState: LayoutUiState = {
  isWidePage: false,
  isTightPage: false,
};

const layoutUiSlice = createSlice({
  name: "layoutUi",
  initialState,
  reducers: {
    setIsWidePage(state, action: PayloadAction<boolean>) {
      state.isWidePage = action.payload;
    },
    setIsTightPage(state, action: PayloadAction<boolean>) {
      state.isTightPage = action.payload;
    },
  },
});

export const { setIsWidePage, setIsTightPage } = layoutUiSlice.actions;
export default layoutUiSlice.reducer;
